import { BrowserModule, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { GtagModule } from 'angular-gtag';
import { AppComponent } from './app.component';
import { AppMaterialModules } from '../material.module';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { ImageLoaderComponent } from './components/image.loader.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SurfaceComponent } from './canvas/components/surface/canvas-surface.component';
import { OptionSelectorComponent } from './canvas/components/optionselector/option-selector.component';
import { OptionSelectorService } from './canvas/services/option-selector.service';
import { GalleryComponent } from './canvas/components/Gallery/gallery.component';
import { ImageComponent, ResourceManager } from './components/resource-manager/resource-manager.component';
import { UploadComponent } from './canvas/components/upload/upload.component';
import { InspirationRoomService } from './canvas/services/inspiration-rooms/inspiration-room.service';

import { LoginService } from './login/services/login.service';

import { LoginComponent } from "./login/login.component";
import { DndDirective } from './directives/dnd.directive';
import { ProgressComponent } from './progress/progress.component';
import { ResizerComponent } from './canvas/components/resizer/resizer.component';
import { MediaService } from './services/media.service';
import { AreasService } from './services/areas.service';
import { CustomFeaturesAddendumService } from './services/custom-features-addendum.service';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ToastrModule } from 'ngx-toastr';
import { RequestInterceptor } from './interceptor/RequestInterceptor';
import { Globals } from './services/globals';
import { SatPopoverModule } from '@ncstate/sat-popover';
import * as Hammer from 'hammerjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BroadcastService } from "./services/broadcast.service";
import { AuthGuard } from "./helpers/auth.guard";
import { JwtInterceptor } from "./helpers/jwt.interceptor";
import { ErrorInterceptor } from "./helpers/error.interceptor";
import { NgxLocalStorageModule } from 'ngx-localstorage';
import { GalleryModule, GALLERY_CONFIG } from 'ng-gallery';
import { IvyCarouselModule } from 'angular-responsive-carousel';

import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION } from 'ngx-ui-loader';

import { TranslatorComponent } from './translator/translator.component';
import { BreadcrumbsComponent } from './client/components/breadcrumbs/breadcrumbs.component';
import { AppHeaderComponent } from './header/app-header.component';
import { WelcomeComponent } from './client/welcome/welcome.component';
import { InspirationOverviewComponent } from './client/inspiration-overview/inspiration-overview.component';
import { SelectionsComponent } from './client/selections/selections.component';
import { DashboardToolbarComponent } from './client/components/dashboard-toolbar/dashboard-toolbar.component';
import { TileComponent } from './client/components/tile/tile.component';
import { SelectionComponent } from './client/selection/selection.component';
import { AppointmentDetailsComponent } from './client/appointment-details/appointment-details.component';
import { CartDetailsComponent } from './client/cart-details/cart-details.component';
import { CustomFeaturesAddendumComponent } from './client/custom-features-addendum/custom-features-addendum.component';
import { VisualizeComponent } from './client/visualize/visualize.component';
import { ErrorComponent } from './error/error.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgxWatermarkModule } from 'ngx-watermark';
import { FaqComponent } from './client/faq/faq.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TooltipModule } from 'ng2-tooltip-directive';
import { BingService } from './services/bing.service';
import { ImageSearchResultsComponent } from './client/image-search-results/image-search-results.component';
import { StyleSelectionsComponent } from './client/components/style-selections/style-selections.component';
import { InspirationComponent } from './client/inspiration/inspiration.component';
import { InspirationReportComponent } from './canvas/components/InspirationsReport/inspirations-report.component';
import { NotificationPanelComponent } from "./components/notification-panel/notification-panel.component";
import { ExportPicturesService } from './services/export-pictures.service';
//import Videogular Modules :: START
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VideoComponent } from './client/video/video.component';
//import Videogular Modules :: END

import { CompletedComponent } from './client/completed/completed.component';
import { OptionSelectionComponent } from './client/option-selection/option-selection.component';
import { NotificationComponent } from './components/notification-component/notification.component';
import { VideoLibraryComponent } from './client/video-library/video-library.component'
import { NgxEditorModule } from "ngx-editor";
import { DiscussionNotesComponent } from './client/selection/discussion-notes/discussion-notes.component';
import { CommonModule } from '@angular/common';
import { RequestAssistanceComponent } from './components/request-assistance/request-assistance.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ImageViewerComponent } from './client/image-viewer/image-viewer.component';
import { UserIdleModule } from 'angular-user-idle';
import { SessionTimeoutSnackComponent } from './components/session-timeout-snack/session-timeout-snack.component';
import { GroupedOptionsModalComponent } from './client/grouped-options-modal/grouped-options-modal.component';
import { environment } from '../environments/environment';


@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'gallery', component: GalleryComponent, canActivate: [AuthGuard] },
  { path: 'inspirationRoomSelection', component: SurfaceComponent },
  { path: 'inspirationRoomSelection/:id/:optionId', component: SurfaceComponent },
  { path: 'resizer/:id/:type/:rid', component: ResizerComponent, canActivate: [AuthGuard] },
  { path: 'edit/:id', component: SurfaceComponent },
  { path: 'upload', component: UploadComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent },
  { path: "canvas-surface", component: SurfaceComponent, canActivate: [AuthGuard] },
  { path: "welcome", component: WelcomeComponent },
  { path: "video", component: VideoComponent },
  { path: "inspiration", component: InspirationOverviewComponent },
  { path: "selections", component: SelectionsComponent },
  { path: "selections/:area", component: SelectionsComponent },
  { path: "selections/:area/:filter", component: SelectionsComponent },
  { path: "selections/:area/:filter/:optionId", component: SelectionsComponent },
  { path: "error", component: ErrorComponent },
  { path: "inspirations", component: InspirationComponent },
  { path: 'inspirationRoomSelection/:room', component: SurfaceComponent },
  { path: 'videoLibrary', component: VideoLibraryComponent },
];

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#f68428",
  fgsColor: "#f68428",
  bgsPosition: POSITION.centerCenter,
  bgsSize: 40,
  bgsType: SPINNER.rectangleBounce, // background spinner type
  fgsType: SPINNER.rectangleBounce, // foreground spinner type
  pbColor: "#f68428",
};

@NgModule({
  declarations: [
    AppComponent,
    ImageLoaderComponent,
    OptionSelectorComponent,
    // Authentication
    LoginComponent,
    AppHeaderComponent,
    // Canvas
    SurfaceComponent,
    GalleryComponent,
    UploadComponent,
    ResizerComponent,
    // Upload
    DndDirective,
    ProgressComponent,
    // POC (Styles)
    //StylerComponent,
    WelcomeComponent,
    InspirationOverviewComponent,
    SelectionsComponent,
    SelectionComponent,
    NotificationPanelComponent,
    TranslatorComponent,
    BreadcrumbsComponent,
    DashboardToolbarComponent,
    TileComponent,
    AppointmentDetailsComponent,
    CartDetailsComponent,
    CustomFeaturesAddendumComponent,
    ErrorComponent,
    FaqComponent,
    ImageSearchResultsComponent,
    StyleSelectionsComponent,
    InspirationComponent,
    InspirationReportComponent,
    VideoComponent,
    OptionSelectionComponent,
    CompletedComponent,
    NotificationComponent,
    VideoLibraryComponent,
    DiscussionNotesComponent,
    RequestAssistanceComponent,
    ImageViewerComponent,
    SessionTimeoutSnackComponent,
    GroupedOptionsModalComponent,
    //VisualizeComponent
  ],
  imports: [
    MatDialogModule,
    CommonModule,
    NgxJsonViewerModule,
    NgxEditorModule,
    //Videogular Modules :: START
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    //Videogular Modules :: END
    NgxWatermarkModule,
    PerfectScrollbarModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    AppMaterialModules,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ImageCropperModule,
    SatPopoverModule,
    HammerModule,
    NgxMatSelectSearchModule,
    IvyCarouselModule,
    RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' }),
    NgxLocalStorageModule.forRoot(),
    GtagModule.forRoot({ trackingId: environment.googleAnalytics, trackPageviews: true }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    GalleryModule,
    FlexLayoutModule,
    TooltipModule,
    [NgxMasonryModule],
    ToastrModule.forRoot({
      progressBar: true,
      preventDuplicates: true,
      progressAnimation: "decreasing",
      timeOut: 5000
    }),
    DragDropModule,
    UserIdleModule.forRoot({ idle: (15 * 60), timeout: (1 * 61), ping: (2 * 60) }),
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalytics),
    NgxGoogleAnalyticsRouterModule
  ],
  exports: [RouterModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: GALLERY_CONFIG, useValue: { dots: true, imageSize: 'contain' } },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: MatDialogRef, useValue: {} },
    Globals,
    OptionSelectorService,
    BingService,
    MediaService,
    AreasService,
    InspirationRoomService,
    LoginService,
    ExportPicturesService,
    ResourceManager,
    BroadcastService,
    CustomFeaturesAddendumService,
    AppMaterialModules,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(far, fal, fas);
  }
}
